import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  FormControlLabel,
  Switch,
  Button,
} from "@material-ui/core";
import { useSnackbar } from "react-simple-snackbar";

import { updateProfile, getProfile } from "../../actions/profile";

const HoldSettings = () => {
  const dispatch = useDispatch();
  const { profiles } = useSelector((state) => state.profiles);
  const user = JSON.parse(localStorage.getItem("profile"));
  const storedProfileDetail = JSON.parse(localStorage.getItem("profileDetail") || "{}");

  const [showStock, setShowStock] = useState(storedProfileDetail?.showStoke || false);
  const [holdEnabled, setHoldEnabled] = useState(storedProfileDetail?.enableHoldKot || false);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [openSnackbar] = useSnackbar();

  useEffect(() => {
    if (user?.userProfile?._id) {
      dispatch(getProfile(user.userProfile._id));
    }
  }, [dispatch, user?.userProfile?._id]);

  useEffect(() => {
    if (!editing) {
      setShowStock(profiles?.showStoke || false);
      setHoldEnabled(profiles?.enableHoldKot || false);
    }
  }, [profiles, editing]);

  const handleSave = async () => {
    if (!profiles?._id) return;
    setSaving(true);
    try {
      await dispatch(
        updateProfile(
          profiles._id,
          {
            ...profiles,
            showStoke: showStock,
            enableHoldKot: holdEnabled,
          },
          openSnackbar
        )
      );
      setEditing(false);
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setShowStock(profiles?.showStoke || false);
    setHoldEnabled(profiles?.enableHoldKot || false);
    setEditing(false);
  };

  return (
    <Card elevation={3} style={{ width: 300, padding: 16, margin: "0.5rem" }}>
      <CardHeader title={<Typography variant="h6">Hold & Stock Settings</Typography>} />
      <CardContent style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <FormControlLabel
          control={
            <Switch
              color="primary"
              checked={showStock}
              onChange={(e) => setShowStock(e.target.checked)}
              disabled={!editing || saving}
            />
          }
          label={showStock ? "Show Stock" : "Hide Stock"}
        />
        <FormControlLabel
          control={
            <Switch
              color="primary"
              checked={holdEnabled}
              onChange={(e) => setHoldEnabled(e.target.checked)}
              disabled={!editing || saving}
            />
          }
          label={holdEnabled ? "Enable Hold KOT" : "Disable Hold KOT"}
        />
   
      </CardContent>
      <CardActions style={{ display: "flex", gap: 8 }}>
        {!editing ? (
          <Button
            variant="contained"
            color="primary"
            onClick={() => setEditing(true)}
            style={{ backgroundColor: "#ef7f1a", color: "#fff" }}
          >
            Edit
          </Button>
        ) : (
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              disabled={saving}
              style={{ backgroundColor: "#ef7f1a", color: "#fff" }}
            >
              {saving ? "Saving…" : "Save"}
            </Button>
            <Button variant="outlined" onClick={handleCancel} disabled={saving}>
              Cancel
            </Button>
          </>
        )}
      </CardActions>
    </Card>
  );
};

export default HoldSettings;

